export const RAW_MATERIAL_OVERHEAD_FACTOR = 0.01;
export const RAW_MATERIAL_BLEND_OVERHEAD_FACTOR = 0.03;
export const HIGH_MONTHLY_VOLUME = 400000;
export const INSPECTION_HIGH_CAVITATION_RATE = 1.75;
export const PACKING_HIGH_CAVITATION_RATE = 1.75;
export const MACHINE_EFFICIENCY = 0.85;
export const CORPORATE_TAX_RATE = 0.2;